import React, { PropsWithoutRef, useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Box,
  Menu,
  MenuItem,
  Typography,
  Button,
} from "@mui/material";
import LockResetIcon from "@mui/icons-material/LockReset";
import PersonIcon from "@mui/icons-material/Person";
import LogoutIcon from "@mui/icons-material/Logout";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import MenuIcon from "@mui/icons-material/Menu";
import { useNavigate } from "react-router-dom";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import "./Layout.scss";
import { SIDEBAR_WIDTH } from "../constants";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

import LogoutModal from "../components/LogoutModal";
import useAuth from "../hooks/useAuth";
import { useLazyGetUserQuery, usePostLogoutMutation } from "../services/auth";
import { User } from "../types/User";
import {
  errorToast,
  getFromStorage,
  STORAGE_KEYS,
  successToast,
} from "../helpers";
import { useDispatch } from "react-redux";
import { setCredentials } from "../reducers/authSlice";
import Loader from "../helpers/constants/Loader";
import { replace } from "formik";
import { setToStorage } from "../constants/storage";
import { useLanguageContext } from "../context/Language";
import useTranslation from "../hooks/Translation";

interface Props {
  handleSidebarToggle: () => void;
}

function Topbar({ handleSidebarToggle }: PropsWithoutRef<Props>) {
  const dispatch = useDispatch();
  const t = useTranslation();
  const navigate = useNavigate();
  const currency = getFromStorage(STORAGE_KEYS.currency);
  const getLang = getFromStorage(STORAGE_KEYS.language);
  const [loading, setLoading] = useState<boolean>(false);
  const [getProfile] = useLazyGetUserQuery();
  const [logoutApi] = usePostLogoutMutation();
  const { language, changeLanguage } = useLanguageContext();
  const [profileDetails, setProfileDetails] = useState<User>();

  const [openLogout, setOpenLogout] = useState<boolean>(false);
  const profileApi = async () => {
    const token = await getFromStorage(STORAGE_KEYS.token);
    console.log(token);
    try {
      setLoading(true);
      const response = await getProfile({}).unwrap();
      if (response.status === 200) {
        dispatch(
          setCredentials({
            token: `${token}`,
            user: response?.data,
          })
        );
        setProfileDetails(response.data);
        setLoading(false);
      }
    } catch (e: any) {
      errorToast(e?.message || "");
      setLoading(false);
    }
  };
  useEffect(() => {
    const token = getFromStorage(STORAGE_KEYS.token);
    const userData = getFromStorage(STORAGE_KEYS.userData);
    if (token) {
      dispatch(
        setCredentials({
          token: token,
          user: null,
        })
      );
      profileApi();
    }
  }, []);
  useEffect(() => {
    if (window) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, []);

  const [scroll, setScroll] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [anchorEl1, setAnchorEl1] = React.useState<null | HTMLElement>(null);
  const open1 = Boolean(anchorEl1);
  const handleClick1 = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl1(event.currentTarget);
  };
  const handleClose1 = () => {
    setAnchorEl1(null);
  };

  const [anchorEl2, setAnchorEl2] = React.useState<null | HTMLElement>(null);

  const open2 = Boolean(anchorEl2);

  const handleClick2 = (event: any) => {
    setAnchorEl2(event.currentTarget);
  };
  const handleClose2 = () => {
    setAnchorEl2(null);
  };

  const [lang, setLang] = React.useState<null | HTMLElement>(null);
  const langOpen = Boolean(lang);
  const handleLanguageClick = (event: any) => {
    setLang(event.currentTarget);
  };
  const handleLanguageClose = () => {
    setLang(null);
  };

  const [rows, setRows] = useState<any>([]);

  const handleLogout = async () => {
    try {
      let response = await logoutApi({}).unwrap();
      if (response?.status === 200) {
        navigate("/", { replace: true });
        // replace("/");
        successToast(response?.message || "");
      }
    } catch (error: any) {
      // errorToast(error?.data?.message || "");
      errorToast(error?.message || "");
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 10);
    });
  }, []);
  const user = useAuth();

  // useEffect(() => {
  //   {
  //     profileApi();
  //   }
  // }, []);
  const getToken = async () => {
    const token = await STORAGE_KEYS?.token;
  };

  const change = () => {
    const body = document.body; // Use document.body directly to get the body element

    if (body) {
      const language = getFromStorage(STORAGE_KEYS.language);
      const isArabic = language === "ar";

      // Remove the opposite class before adding the new one
      body.classList.remove(isArabic ? "english_lang" : "arabic_lang");
      body.classList.add(isArabic ? "arabic_lang" : "english_lang");
    }
  };

  const handleLangChange = (val: string) => {
    setTimeout(() => {
      // Perform other actions after the page is reloaded
      window.location.reload();
      setToStorage(STORAGE_KEYS.language, val);
      changeLanguage(val);
      setLang(null);
    }, 500);
  };

  useEffect(() => {
    change();
  }, [getLang]);

  useEffect(() => {
    getToken();
  }, []);

  return (
    <Box className="top_bar">
      <AppBar
        position="fixed"
        className="topbar"
        sx={{
          width: { lg: `calc(100% - ${SIDEBAR_WIDTH}px)` },
          ml: { lg: getLang === "en" ? `${280}px` : 0 },
          mr: { lg: getLang === "ar" ? `${280}px` : 0 },
        }}
      >
        <Loader loading={loading} />
        <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
          <IconButton
            color="inherit"
            aria-label="open sidebar"
            edge="start"
            onClick={handleSidebarToggle}
            style={{ backgroundColor: "#72cedd" }}
            sx={{
              display: { xs: "flex", lg: "none" },
            }}
          >
            <MenuIcon />
          </IconButton>
          <Box
            className="topbar_rt"
            sx={{
              ml: { lg: getLang === "en" || getLang === "ru" ? "auto" : 0 },
              mr: { lg: getLang === "ar" ? "auto" : 0 },
            }}
          >
            <Box>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={(e) => handleLanguageClick(e)}
              >
                <p style={{ color: "black", fontSize: "14px" }}>
                  {getLang === "ar" ? "Ar" : getLang === "ru" ? "Ru" : "En"}
                </p>
                <ArrowDropDownIcon sx={{ color: "black" }} />
                {/* <span className="notification_badge">0</span> */}
              </div>
              <Menu
                className="notiDropdown_menu2"
                id="basic-menu1"
                anchorEl={lang}
                open={langOpen}
                onClose={handleLanguageClose}
                MenuListProps={{
                  "aria-labelledby": "basic-button1",
                }}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    mt: 1.5,
                    "& .MuiAvatar-root": {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    "&:before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 10,
                      width: 10,
                      height: 10,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <MenuItem
                  onClick={() => handleLangChange("en")}
                  className="userDropdown_menu_list"
                  selected={getLang === "en"}
                >
                  En
                </MenuItem>
                <MenuItem
                  onClick={() => handleLangChange("ar")}
                  className="userDropdown_menu_list"
                  selected={getLang === "ar"}
                >
                  Ar
                </MenuItem>
                <MenuItem
                  onClick={() => handleLangChange("ru")}
                  className="userDropdown_menu_list"
                  selected={getLang === "ru"}
                >
                  Ru
                </MenuItem>
              </Menu>
            </Box>

            <Box>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={(e) => handleClick2(e)}
              >
                <p style={{ color: "black", fontSize: "14px" }}>
                  {currency === "USD" ? "USD" : "AED"}
                </p>
                <ArrowDropDownIcon sx={{ color: "black" }} />
                {/* <span className="notification_badge">0</span> */}
              </div>
              <Menu
                className="notiDropdown_menu2"
                id="basic-menu1"
                anchorEl={anchorEl2}
                open={open2}
                onClose={handleClose2}
                MenuListProps={{
                  "aria-labelledby": "basic-button1",
                }}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    mt: 1.5,
                    "& .MuiAvatar-root": {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    "&:before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 10,
                      width: 10,
                      height: 10,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <MenuItem
                  selected={currency === "AED"}
                  onClick={() => {
                    setToStorage(STORAGE_KEYS.currency, "AED");
                    window.location.reload();
                  }}
                  className="userDropdown_menu_list"
                >
                  AED
                </MenuItem>
                <MenuItem
                  selected={currency === "USD"}
                  onClick={() => {
                    setToStorage(STORAGE_KEYS.currency, "USD");
                    window.location.reload();
                  }}
                  className="userDropdown_menu_list"
                >
                  USD
                </MenuItem>
              </Menu>
            </Box>
            <Box>
              <IconButton
                className="icon_btn"
                aria-controls={open1 ? "basic-menu1" : undefined}
                aria-haspopup="true"
                aria-expanded={open1 ? "true" : undefined}
                onClick={handleClick1}
              >
                <NotificationsActiveIcon />

                {/* <span className="notification_badge">0</span> */}
              </IconButton>
              <Menu
                className="notiDropdown_menu"
                id="basic-menu1"
                anchorEl={anchorEl1}
                open={open1}
                onClose={handleClose1}
                MenuListProps={{
                  "aria-labelledby": "basic-button1",
                }}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    mt: 1.5,
                    "& .MuiAvatar-root": {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    "&:before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 10,
                      width: 10,
                      height: 10,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <Box className="noti_head">
                  <Typography component="h2">Notifications</Typography>
                  <Button
                    className="btn btn_primary sm"
                    onClick={() => {
                      handleClose1();
                      navigate("/recieved-notifications");
                    }}
                  >
                    See All
                  </Button>
                </Box>
                <ul className="noti_list">
                  {rows?.slice(0, 3)?.length > 0 ? (
                    <>
                      {rows
                        ?.slice(0, 3)
                        ?.map((notification: any, index: number) => (
                          <li key={index}>
                            <div className="noti_info">
                              <Typography component="h3">
                                {notification.title}
                              </Typography>
                              <Typography component="p">
                                {notification.message}
                              </Typography>
                            </div>
                          </li>
                        ))}
                    </>
                  ) : (
                    <Typography style={{ padding: 10 }}>
                      No notification received
                    </Typography>
                  )}
                </ul>
              </Menu>
            </Box>
            <Box>
              <IconButton
                className="topbar_user_btn"
                aria-controls={open ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick}
              >
                <img
                  src={
                    user?.profile_picture?.media_url ||
                    "/static/images/user_placeholder.png"
                  }
                  alt=""
                />
                <span>{user?.full_name || ""}</span>
                <KeyboardArrowDownIcon />
              </IconButton>
              <Menu
                className="userDropdown_menu"
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    mt: 1.5,
                    "& .MuiAvatar-root": {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    "&:before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 10,
                      width: 10,
                      height: 10,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <MenuItem
                  className="userDropdown_menu_list"
                  onClick={() => navigate("/profile")}
                >
                  <IconButton className="drpdwn_icns">
                    <PersonIcon />
                  </IconButton>
                  {t.main.myProfile}
                </MenuItem>
                <MenuItem
                  className="userDropdown_menu_list"
                  onClick={() => navigate("/changepassword")}
                >
                  <IconButton className="drpdwn_icns">
                    <LockResetIcon />
                  </IconButton>
                  {t.main.changePassword}
                </MenuItem>

                <MenuItem
                  className="userDropdown_menu_list"
                  onClick={() => setOpenLogout(true)}
                >
                  <IconButton className="drpdwn_icns">
                    <LogoutIcon />
                  </IconButton>
                  {t.main.logout}
                </MenuItem>
              </Menu>
            </Box>
          </Box>
        </Toolbar>
      </AppBar>
      <LogoutModal
        openLogout={openLogout}
        setOpenLogout={setOpenLogout}
        handleLogout={handleLogout}
      />
    </Box>
  );
}

export default Topbar;
